import { accordion } from './accordion';
import { button } from './button';
import { card } from './card';
import { carousel } from './carousel';
import { footer } from './footer';
import { header } from './header';
import { logo } from './logo';
import { price } from './price-label';
import { productCard } from './product-card';
import { section } from './section';
import { slideshow } from './slide-show';

export default {
  accordion,
  button,
  card,
  carousel,
  footer,
  header,
  logo,
  price,
  productCard,
  section,
  slideshow,
};
